import type { PageConfig } from '~/types';

const schoolYearViewConfig: PageConfig = {
  route: {
    path: '/:schoolSlug/years/:yearSlug',
    params: ['schoolSlug', 'yearSlug'],
  },
  queryParams: {},
  schema: {
    queries: ['currentUser', 'school'],
    fragments: ['SidebarFragment'],
    types: ['School', 'SchoolYear'],
  },
};

export default schoolYearViewConfig;
